var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetPreviousLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 2,
    viewBox: "0 0 10 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.74228e-08 1C-3.91405e-08 0.447715 0.149238 1.30468e-08 0.333333 2.91409e-08L9.66667 8.45087e-07C9.85076 8.61182e-07 10 0.447716 10 1C10 1.55228 9.85076 2 9.66667 2L0.333333 2C0.149238 2 -1.35705e-07 1.55228 -8.74228e-08 1Z",
    fill: "#181331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetPreviousLine);
export default __webpack_public_path__ + "static/media/target-Previous-line.2d1eb677cc28f38e81dfbeab5d18f66e.svg";
export { ForwardRef as ReactComponent };